import { FaturamentoProduto } from './faturamento-produto.model';
import { Portaria } from './portaria.model';

export class TrocaPpbPdi {

  id: number;
  faturamentoProduto: FaturamentoProduto;
  portaria: Portaria;
  percentualEspecificado: number;
  projetoConveniado: boolean;
  obrigacaoProjetoConveniado: number;
  projetoProprio: boolean;
  obrigacaoProjetoProprio: number;
  fndct: boolean;
  obrigacaoFndct: number;
  ppi: boolean;
  obrigacaoPpi: number;
  trocaTotalFaturamento: boolean;
  valorFaturamentoTroca: number
  quantidadeProduzidaTroca: number;
  
  constructor(init?: Partial<TrocaPpbPdi>) {
    Object.assign(this, init);
  }

}
